export default __webpack_public_path__ + "static/media/error_round_bg.a492ad7d.svg";